module.exports = __webpack_public_path__ + "img/c10.e27acfd8.png";